(function () {
  const setImageSource = (image, source, alt) => {
    if (!image || !source) return;
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = source;
    if (typeof alt === 'string') image.alt = alt;
  };

  const applySurpriseChoice = (choice) => {
    const form = choice?.closest('[data-ar-surprise-form]');
    const card = choice?.closest('[data-ar-surprise-upsell]');
    if (!form || !card) return;

    const variantInput = form.querySelector('[data-ar-surprise-variant]');
    const previewImage = card.querySelector('[data-ar-surprise-image]');
    const selection = form.querySelector('[data-ar-surprise-selection]');
    const submit = form.querySelector('[data-ar-surprise-submit]');

    if (variantInput) variantInput.value = choice.value;
    if (previewImage && choice.dataset.image) {
      previewImage.src = choice.dataset.image;
      previewImage.removeAttribute('srcset');
      previewImage.alt = `Arelio Good Energy ${choice.dataset.title || 'crochet friend'}`;
    }
    if (selection) selection.textContent = choice.dataset.title || 'Selected friend';
    if (submit) submit.textContent = `Add ${choice.dataset.title || 'selected friend'} · ${choice.dataset.price || ''}`.trim();
  };

  const applyDonationPreset = (choice) => {
    const form = choice?.closest('[data-ar-donation-form]');
    if (!form) return;
    const variantInput = form.querySelector('[data-ar-donation-variant]');
    const quantityInput = form.querySelector('[data-ar-donation-quantity]');
    const propertyInput = form.querySelector('[data-ar-donation-property]');
    const submit = form.querySelector('[data-ar-donation-submit]');
    const customToggle = form.querySelector('[data-ar-donation-custom-toggle]');
    const customPanel = form.querySelector('[data-ar-donation-custom]');
    const customInput = form.querySelector('[data-ar-donation-custom-input]');
    const label = choice.dataset.title || '';

    form.dataset.arDonationMode = 'preset';
    if (variantInput) variantInput.value = choice.value;
    if (quantityInput) quantityInput.value = '1';
    if (propertyInput) propertyInput.value = label;
    if (submit) submit.textContent = `Donate ${label}`.trim();
    if (customToggle) {
      customToggle.classList.remove('is-active');
      customToggle.setAttribute('aria-expanded', 'false');
    }
    if (customPanel) customPanel.hidden = true;
    if (customInput) customInput.required = false;
  };

  const applyCustomDonation = (form, focusInput = false) => {
    if (!form?.dataset.arCustomDonationVariant) return;
    const variantInput = form.querySelector('[data-ar-donation-variant]');
    const quantityInput = form.querySelector('[data-ar-donation-quantity]');
    const propertyInput = form.querySelector('[data-ar-donation-property]');
    const submit = form.querySelector('[data-ar-donation-submit]');
    const customToggle = form.querySelector('[data-ar-donation-custom-toggle]');
    const customPanel = form.querySelector('[data-ar-donation-custom]');
    const customInput = form.querySelector('[data-ar-donation-custom-input]');
    if (!customInput) return;

    const rawAmount = Number.parseInt(customInput.value, 10);
    const hasAmount = Number.isFinite(rawAmount);
    const amount = hasAmount ? Math.min(500, Math.max(1, rawAmount)) : 1;
    if (hasAmount && String(amount) !== customInput.value) customInput.value = String(amount);
    customInput.required = true;
    form.dataset.arDonationMode = 'custom';
    form.querySelectorAll('[data-ar-donation-choice]').forEach((choice) => { choice.checked = false; });
    if (variantInput) variantInput.value = form.dataset.arCustomDonationVariant;
    if (quantityInput) quantityInput.value = String(amount);
    if (propertyInput) propertyInput.value = hasAmount ? `$${amount.toFixed(2)} custom donation` : 'Custom donation';
    if (submit) submit.textContent = hasAmount ? `Donate $${amount.toFixed(2)}` : 'Donate custom amount';
    if (customToggle) {
      customToggle.classList.add('is-active');
      customToggle.setAttribute('aria-expanded', 'true');
    }
    if (customPanel) customPanel.hidden = false;
    if (focusInput) customInput.focus();
  };

  const initSurpriseUpsell = (root = document) => {
    root.querySelectorAll('[data-ar-surprise-form]:not([data-ar-ready])').forEach((form) => {
      form.dataset.arReady = 'true';
      const choices = form.querySelector('.ar-good-energy-upsell__choices');
      if (choices) {
        const choicesTrack = choices.querySelector('[data-ar-surprise-choices-track]') || choices;
        [...choices.querySelectorAll('.ar-good-energy-upsell__choice')]
          .sort((a, b) => Number(a.querySelector('input')?.dataset.order) - Number(b.querySelector('input')?.dataset.order))
          .forEach((choice) => choicesTrack.appendChild(choice));
      }
      applySurpriseChoice(form.querySelector('[data-ar-good-energy-choice]:checked'));
    });

    root.querySelectorAll('[data-ar-donation-form]:not([data-ar-ready])').forEach((form) => {
      form.dataset.arReady = 'true';
      const choice = form.querySelector('[data-ar-donation-choice]:checked');
      if (choice) applyDonationPreset(choice);
      form.addEventListener('submit', (event) => {
        if (form.dataset.arDonationMode !== 'custom') return;
        applyCustomDonation(form);
        const input = form.querySelector('[data-ar-donation-custom-input]');
        if (input && !input.checkValidity()) {
          event.preventDefault();
          input.reportValidity();
        }
      });
    });
  };

  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-ar-good-energy-choice]')) applySurpriseChoice(event.target);
    if (event.target.matches('[data-ar-donation-choice]')) applyDonationPreset(event.target);
    if (event.target.matches('[data-ar-donation-custom-input]')) applyCustomDonation(event.target.closest('[data-ar-donation-form]'));
  });

  document.addEventListener('input', (event) => {
    if (event.target.matches('[data-ar-donation-custom-input]')) applyCustomDonation(event.target.closest('[data-ar-donation-form]'));
  });

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-ar-donation-custom-toggle]');
    if (toggle) applyCustomDonation(toggle.closest('[data-ar-donation-form]'), true);
  });

  initSurpriseUpsell();
  document.documentElement.classList.add('ar-reveal-ready');
  const initReveal = (root = document) => {
    const items = root.querySelectorAll('.ar-reveal:not([data-ar-ready])');
    if (!items.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }
    if (!('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        obs.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px' });
    items.forEach((item, index) => {
      item.dataset.arReady = 'true';
      item.style.transitionDelay = `${Math.min(index % 4, 3) * 70}ms`;
      observer.observe(item);
    });
  };

  const initFaq = (root = document) => {
    root.querySelectorAll('.ar-faq__question:not([data-ar-ready])').forEach((button) => {
      button.dataset.arReady = 'true';
      button.addEventListener('click', () => {
        const item = button.closest('.ar-faq__item');
        const open = item.classList.toggle('is-open');
        button.setAttribute('aria-expanded', String(open));
      });
    });
  };

  const loadVimeoSdk = () => {
    if (window.Vimeo?.Player) return Promise.resolve(window.Vimeo);
    if (window.__arVimeoSdkPromise) return window.__arVimeoSdkPromise;
    window.__arVimeoSdkPromise = new Promise((resolve, reject) => {
      const existing = document.querySelector('script[data-ar-vimeo-sdk]');
      const script = existing || document.createElement('script');
      if (!existing) {
        script.src = 'https://player.vimeo.com/api/player.js';
        script.async = true;
        script.dataset.arVimeoSdk = 'true';
        document.head.appendChild(script);
      }
      script.addEventListener('load', () => resolve(window.Vimeo), { once: true });
      script.addEventListener('error', reject, { once: true });
    });
    return window.__arVimeoSdkPromise;
  };

  const initGallery = (root = document) => {
    root.querySelectorAll('.ar-pdp:not([data-ar-gallery-ready])').forEach((section) => {
      section.dataset.arGalleryReady = 'true';
      const main = section.querySelector('.ar-pdp__main-image');
      const caption = section.querySelector('[data-ar-media-caption]');
      const captionTitle = section.querySelector('[data-ar-caption-title]');
      const captionText = section.querySelector('[data-ar-caption-text]');
      const videoPanel = section.querySelector('[data-ar-product-video]');
      const videoFrame = section.querySelector('[data-ar-video-frame]');
      const videoPlayer = section.querySelector('[data-ar-video-player]');
      const videoReplay = section.querySelector('[data-ar-video-replay]');
      let activeVideoType = '';
      let activeVideoUrl = '';
      let vimeoPlayer = null;

      const updateCaption = (button) => {
        if (!caption || !captionTitle || !captionText) return;
        const title = button?.dataset.captionTitle || '';
        const text = button?.dataset.captionText || '';
        captionTitle.textContent = title;
        captionText.textContent = text;
        caption.hidden = !title && !text;
      };

      const resetVideo = () => {
        if (vimeoPlayer) {
          try { vimeoPlayer.off('ended'); } catch (error) {}
          vimeoPlayer = null;
        }
        if (videoFrame) {
          videoFrame.removeAttribute('src');
          videoFrame.hidden = true;
        }
        if (videoPlayer) {
          videoPlayer.pause();
          videoPlayer.removeAttribute('src');
          videoPlayer.load();
          videoPlayer.hidden = true;
        }
        if (videoReplay) videoReplay.hidden = true;
        if (videoPanel) videoPanel.hidden = true;
        if (main) main.hidden = false;
        activeVideoType = '';
        activeVideoUrl = '';
      };

      const showReplay = () => {
        if (!videoReplay) return;
        videoReplay.hidden = false;
      };

      const showVideo = (button) => {
        if (!main || !videoPanel) return;
        resetVideo();
        activeVideoType = button.dataset.videoType || 'mp4';
        activeVideoUrl = button.dataset.videoUrl || '';
        const poster = button.querySelector('img')?.currentSrc || button.querySelector('img')?.src || '';
        if (videoReplay && poster) {
          videoReplay.style.backgroundImage = `linear-gradient(rgba(3, 7, 6, .72), rgba(3, 7, 6, .88)), url("${poster.replace(/"/g, '\\"')}")`;
        }
        main.hidden = true;
        videoPanel.hidden = false;
        if (button.dataset.videoType === 'vimeo' && videoFrame) {
          const joiner = button.dataset.videoUrl.includes('?') ? '&' : '?';
          videoFrame.src = `${button.dataset.videoUrl}${joiner}autoplay=1&title=0&byline=0&portrait=0&dnt=1`;
          videoFrame.hidden = false;
          loadVimeoSdk().then(() => {
            if (activeVideoType !== 'vimeo' || activeVideoUrl !== button.dataset.videoUrl || !window.Vimeo?.Player) return;
            vimeoPlayer = new window.Vimeo.Player(videoFrame);
            vimeoPlayer.on('ended', showReplay);
          }).catch(() => {});
        } else if (videoPlayer) {
          videoPlayer.src = button.dataset.videoUrl;
          videoPlayer.hidden = false;
          videoPlayer.play().catch(() => {});
        }
        updateCaption(null);
      };

      if (videoPlayer) videoPlayer.addEventListener('ended', showReplay);
      if (videoReplay) {
        videoReplay.addEventListener('click', () => {
          videoReplay.hidden = true;
          if (activeVideoType === 'vimeo' && videoFrame) {
            videoFrame.hidden = false;
            if (vimeoPlayer) {
              vimeoPlayer.setCurrentTime(0).then(() => vimeoPlayer.play()).catch(() => {});
            } else if (videoFrame.src) {
              const source = videoFrame.src;
              videoFrame.removeAttribute('src');
              window.setTimeout(() => { videoFrame.src = source; }, 0);
            }
          } else if (videoPlayer) {
            videoPlayer.currentTime = 0;
            videoPlayer.hidden = false;
            videoPlayer.play().catch(() => {});
          }
        });
      }

      section.addEventListener('ar:gallery-reset', resetVideo);

      section.querySelectorAll('.ar-pdp__thumb').forEach((button) => {
        button.addEventListener('click', () => {
          if (!main) return;
          if (button.dataset.videoUrl) {
            showVideo(button);
          } else {
            resetVideo();
            setImageSource(main, button.dataset.src, button.dataset.alt || '');
            updateCaption(button);
          }
          section.querySelectorAll('.ar-pdp__thumb').forEach((thumb) => thumb.classList.remove('is-active'));
          button.classList.add('is-active');
        });
      });
    });
  };

  const initVariants = (root = document) => {
    root.querySelectorAll('.ar-pdp:not([data-ar-variant-ready])').forEach((section) => {
      section.dataset.arVariantReady = 'true';
      const json = section.querySelector('[data-ar-variants]');
      if (!json) return;
      const variants = JSON.parse(json.textContent);
      const galleryJson = section.querySelector('[data-ar-gallery-map]');
      let galleryMap = null;
      if (galleryJson) {
        try {
          galleryMap = JSON.parse(galleryJson.textContent);
        } catch (error) {
          console.warn('Arelio gallery map could not be read.', error);
        }
      }
      const selects = section.querySelectorAll('[data-ar-option]');
      const visualGroups = section.querySelectorAll('[data-ar-visual-group]');
      const idInput = section.querySelector('input[name="id"]');
      const price = section.querySelector('[data-ar-price]');
      const compare = section.querySelector('[data-ar-compare]');
      const offer = section.querySelector('[data-ar-pdp-offer]');
      const offerTitle = offer?.querySelector('[data-ar-offer-title]');
      const offerDetail = offer?.querySelector('[data-ar-offer-detail]');
      const submit = section.querySelector('[data-ar-submit]');
      const label = section.querySelector('[data-ar-submit-label]');
      const story = document.querySelector(`[data-ar-flagship][data-product-handle="${section.dataset.productHandle || ''}"]`);
      const storyPrice = story?.querySelector('[data-ar-story-price]');
      const mainImage = section.querySelector('.ar-pdp__main-image');
      const caption = section.querySelector('[data-ar-media-caption]');

      const applyGallery = (gallery) => {
        if (!gallery?.length || !mainImage) return false;
        section.dispatchEvent(new CustomEvent('ar:gallery-reset'));
        const thumbs = Array.from(section.querySelectorAll('.ar-pdp__thumb[data-ar-gallery-thumb]'));
        thumbs.forEach((thumb, index) => {
          const item = gallery[index];
          thumb.hidden = !item?.src;
          thumb.classList.toggle('is-active', index === 0 && !!item?.src);
          if (!item?.src) return;
          const image = thumb?.querySelector('img');
          if (!image) return;
          thumb.dataset.src = item.src;
          thumb.dataset.alt = item.alt || '';
          delete thumb.dataset.captionTitle;
          delete thumb.dataset.captionText;
          setImageSource(image, item.src, item.alt || '');
        });
        setImageSource(mainImage, gallery[0].src, gallery[0].alt || mainImage.alt);
        if (caption) caption.hidden = true;

        const handle = section.dataset.productHandle || '';
        document.querySelectorAll('[data-ar-flagship]').forEach((story) => {
          if (story.dataset.productHandle !== handle) return;
          story.querySelectorAll('[data-ar-gallery-slot]').forEach((image) => {
            const slot = Number(image.dataset.arGallerySlot);
            const item = gallery[slot];
            if (!item?.src) return;
            image.classList.add('is-changing');
            window.setTimeout(() => {
              setImageSource(image, item.src, item.alt || image.alt);
              image.classList.remove('is-changing');
            }, 120);
          });
        });
        return true;
      };

      const update = () => {
        const selected = Array.from(selects).map((select) => select.value);
        const variant = selects.length ? variants.find((item) => item.options.every((option, index) => option === selected[index])) : variants[0];
        if (!variant) {
          submit.disabled = true;
          label.textContent = 'Unavailable';
          return;
        }
        idInput.value = variant.id;
        price.textContent = variant.price;
        if (storyPrice) storyPrice.textContent = variant.price;
        if (compare) {
          compare.textContent = variant.compare || '';
          compare.hidden = !variant.compare;
        }
        if (offer && offerTitle && offerDetail) {
          const priceCents = Number(variant.priceCents);
          const isTalkButton = offer.dataset.productHandle === 'arelio-talkbutton-30-second-recordable-pet-button';
          if (isTalkButton) {
            offerTitle.textContent = '$5 off $35+ during launch';
            offerDetail.textContent = 'Applies after set pricing when the cart subtotal reaches $35';
          } else if (priceCents >= 3500) {
            offerTitle.textContent = 'This item unlocks $5 off';
            offerDetail.textContent = `${variant.launchPrice} at checkout when purchased alone`;
          } else {
            offerTitle.textContent = 'Launch offer · $5 off $35+';
            offerDetail.textContent = `Add ${variant.offerGap} more to unlock automatically`;
          }
        }
        submit.disabled = !variant.available;
        label.textContent = variant.available ? 'Add to cart' : 'Sold out';
        const galleryKey = variant.options.join(' / ');
        const gallery = galleryMap?.[galleryKey] || galleryMap?.[variant.options[0]];
        const galleryApplied = applyGallery(gallery);
        if (!galleryApplied && variant.image && mainImage) {
          setImageSource(mainImage, variant.image, variant.imageAlt || mainImage.alt);
          section.querySelectorAll('.ar-pdp__thumb[data-ar-gallery-thumb]').forEach((thumb) => thumb.classList.remove('is-active'));
          let matchingThumb = Array.from(section.querySelectorAll('.ar-pdp__thumb[data-ar-gallery-thumb]')).find((thumb) => thumb.dataset.src === variant.image);
          if (!matchingThumb) {
            const studioThumb = section.querySelector('.ar-pdp__thumb[data-ar-gallery-thumb]:not([data-caption-title])');
            const studioImage = studioThumb?.querySelector('img');
            if (studioThumb && studioImage) {
              studioThumb.dataset.src = variant.image;
              studioThumb.dataset.alt = variant.imageAlt || mainImage.alt;
              setImageSource(studioImage, variant.image, variant.imageAlt || mainImage.alt);
              matchingThumb = studioThumb;
            }
          }
          if (matchingThumb) matchingThumb.classList.add('is-active');
          if (caption) caption.hidden = true;
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
        visualGroups.forEach((group, index) => {
          const selectedValue = selects[index]?.value;
          const selectedLabel = group.querySelector('[data-ar-selected-option]');
          group.querySelectorAll('[data-ar-visual-option]').forEach((button) => {
            const isSelected = button.dataset.value === selectedValue;
            const isAvailable = variants.some((item) => item.available && item.options[index] === button.dataset.value);
            button.classList.toggle('is-selected', isSelected);
            button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
            button.disabled = !isAvailable;
            button.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');
            const status = button.querySelector('small');
            if (status) status.textContent = isAvailable ? 'Available' : 'Currently unavailable';
          });
          const activeButton = group.querySelector(`[data-ar-visual-option][data-value="${CSS.escape(selectedValue || '')}"] strong`);
          if (selectedLabel) selectedLabel.textContent = activeButton?.textContent || selectedValue || '';
        });
      };
      visualGroups.forEach((group, optionIndex) => {
        group.querySelectorAll('[data-ar-visual-option]').forEach((button) => {
          button.addEventListener('click', () => {
            if (button.disabled || !selects[optionIndex]) return;
            const selected = Array.from(selects).map((select) => select.value);
            const directMatch = variants.find((item) => item.available && item.options[optionIndex] === button.dataset.value && item.options.every((value, index) => index === optionIndex || value === selected[index]));
            const fallbackMatch = directMatch || variants.find((item) => item.available && item.options[optionIndex] === button.dataset.value);
            if (!fallbackMatch) return;
            selects.forEach((select, index) => { select.value = fallbackMatch.options[index]; });
            update();
          });
        });
      });
      selects.forEach((select) => select.addEventListener('change', update));
      update();
    });
  };

  const initTalkButtonSets = (root = document) => {
    root.querySelectorAll('[data-ar-talk-set]:not([data-ar-ready])').forEach((builder) => {
      builder.dataset.arReady = 'true';
      const section = builder.closest('.ar-pdp');
      const productForm = section?.querySelector('product-form');
      const form = productForm?.querySelector('form');
      if (!section || !productForm || !form) return;

      const modeButtons = Array.from(builder.querySelectorAll('[data-ar-talk-mode]'));
      const colorPanel = builder.querySelector('[data-ar-talk-colors]');
      const colorSlots = Array.from(builder.querySelectorAll('[data-ar-talk-color-slot]'));
      const colorSelects = Array.from(builder.querySelectorAll('[data-ar-talk-color]'));
      const note = builder.querySelector('[data-ar-talk-set-note]');
      const standardControls = Array.from(form.querySelectorAll('[data-ar-talk-single-controls]'));
      const optionSelect = form.querySelector('[data-ar-option]');
      const quantityInput = form.querySelector('[name="quantity"]');
      const submit = form.querySelector('[data-ar-submit]');
      const submitLabel = form.querySelector('[data-ar-submit-label]');
      const spinner = form.querySelector('.loading__spinner');
      const price = section.querySelector('[data-ar-price]');
      const compare = section.querySelector('[data-ar-compare]');
      const randomOption = optionSelect
        ? Array.from(optionSelect.options).find((option) => option.textContent.includes('4-button set'))
        : null;
      let mode = 'single';

      colorSelects.forEach((select, index) => {
        if (select.options.length) select.selectedIndex = Math.min(index, select.options.length - 1);
      });

      const selectFirstSingle = () => {
        if (!optionSelect) return;
        const singleOption = Array.from(optionSelect.options).find((option) => option !== randomOption);
        if (!singleOption || optionSelect.value !== randomOption?.value) return;
        optionSelect.value = singleOption.value;
        optionSelect.dispatchEvent(new Event('change', { bubbles: true }));
      };

      const updateMode = (nextMode) => {
        mode = nextMode;
        const customCount = mode === 'pair' ? 2 : mode === 'trio' ? 3 : 0;
        modeButtons.forEach((button) => {
          const selected = button.dataset.arTalkMode === mode;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-checked', selected ? 'true' : 'false');
        });
        if (colorPanel) colorPanel.hidden = customCount === 0;
        colorSlots.forEach((slot, index) => { slot.hidden = index >= customCount; });
        standardControls.forEach((control) => { control.hidden = mode !== 'single'; });
        if (quantityInput) {
          quantityInput.value = '1';
          quantityInput.disabled = mode === 'pair' || mode === 'trio';
        }

        if (mode === 'random' && optionSelect && randomOption) {
          optionSelect.value = randomOption.value;
          optionSelect.dispatchEvent(new Event('change', { bubbles: true }));
          if (price) price.textContent = '$39.99';
          if (compare) compare.hidden = true;
          if (submitLabel) submitLabel.textContent = 'Add 4 random colors';
          if (note) note.innerHTML = '<strong>4 for $39.99.</strong> The supplier selects the four colors at random.';
          return;
        }

        selectFirstSingle();
        if (mode === 'pair') {
          if (price) price.textContent = '$29.99';
          if (compare) compare.hidden = true;
          if (submitLabel) submitLabel.textContent = 'Add 2 chosen buttons';
          if (note) note.innerHTML = '<strong>2 for $29.99.</strong> Select two colors; set pricing applies automatically in the cart.';
        } else if (mode === 'trio') {
          if (price) price.textContent = '$39.99';
          if (compare) compare.hidden = true;
          if (submitLabel) submitLabel.textContent = 'Add 3 chosen buttons';
          if (note) note.innerHTML = '<strong>3 for $39.99.</strong> Select three colors; set pricing applies automatically in the cart.';
        } else {
          if (optionSelect) optionSelect.dispatchEvent(new Event('change', { bubbles: true }));
          if (submitLabel) submitLabel.textContent = 'Add to cart';
          if (note) note.textContent = 'Choose one color below.';
        }
      };

      modeButtons.forEach((button) => {
        button.addEventListener('click', () => {
          if (!button.disabled) updateMode(button.dataset.arTalkMode || 'single');
        });
      });

      form.addEventListener('submit', async (event) => {
        if (mode !== 'pair' && mode !== 'trio') return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (submit?.getAttribute('aria-disabled') === 'true') return;

        const count = mode === 'pair' ? 2 : 3;
        const quantities = new Map();
        colorSelects.slice(0, count).forEach((select) => {
          if (!select.value) return;
          quantities.set(select.value, (quantities.get(select.value) || 0) + 1);
        });
        const items = Array.from(quantities, ([id, quantity]) => ({ id: Number(id), quantity }));
        if (!items.length) return;

        productForm.handleErrorMessage?.();
        submit?.setAttribute('aria-disabled', 'true');
        submit?.classList.add('loading');
        spinner?.classList.remove('hidden');

        try {
          const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          const payload = { items };
          if (cart) {
            payload.sections = cart.getSectionsToRender().map((item) => item.id);
            payload.sections_url = window.location.pathname;
            cart.setActiveElement?.(document.activeElement);
          }
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(payload),
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || result.message || 'The selected set could not be added.');

          if (cart && result.sections) {
            if (cart.tagName === 'CART-NOTIFICATION') {
              result.key = result.items?.[0]?.key;
            }
            cart.renderContents(result);
          } else {
            window.location.assign(window.routes?.cart_url || '/cart');
          }
        } catch (error) {
          productForm.handleErrorMessage?.(error.message);
        } finally {
          submit?.classList.remove('loading');
          submit?.removeAttribute('aria-disabled');
          spinner?.classList.add('hidden');
        }
      }, true);

      updateMode('single');
    });
  };

  const initHeroSliders = (root = document) => {
    root.querySelectorAll('[data-ar-hero-slider]:not([data-ar-slider-ready])').forEach((slider) => {
      slider.dataset.arSliderReady = 'true';
      const slides = Array.from(slider.querySelectorAll('[data-ar-hero-slide]'));
      if (slides.length < 2) return;

      const duration = Math.max(Number(slider.dataset.duration) || 7000, 4000);
      const autoEnabled = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let current = 0;
      let timer = null;
      let pointerId = null;
      let startX = 0;
      let startY = 0;
      let touchTracking = false;
      let touchStartX = 0;
      let touchStartY = 0;
      let touchCurrentX = 0;
      let touchCurrentY = 0;
      let wheelDeltaX = 0;
      let wheelLocked = false;
      let wheelUnlockTimer = null;
      let wheelLastEventAt = 0;
      let wheelLastChangeAt = 0;
      let wheelPreviousMagnitude = 0;
      let suppressClick = false;
      let hovered = false;
      let focused = false;

      const show = (nextIndex) => {
        current = (nextIndex + slides.length) % slides.length;
        slides.forEach((slide, index) => {
          const active = index === current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
      };

      const stop = () => {
        if (timer) window.clearInterval(timer);
        timer = null;
      };
      const start = () => {
        stop();
        if (autoEnabled && !document.hidden && !hovered && !focused) {
          timer = window.setInterval(() => show(current + 1), duration);
        }
      };

      const applySwipe = (dx, dy, threshold = 40) => {
        if (Math.abs(dx) < threshold || Math.abs(dx) <= Math.abs(dy) * 1.05) return false;
        suppressClick = true;
        show(current + (dx < 0 ? 1 : -1));
        return true;
      };

      slider.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'touch' || !event.isPrimary || event.button > 0) return;
        pointerId = event.pointerId;
        startX = event.clientX;
        startY = event.clientY;
        suppressClick = false;
        slider.setPointerCapture?.(pointerId);
        stop();
      });
      slider.addEventListener('pointerup', (event) => {
        if (event.pointerId !== pointerId) return;
        const dx = event.clientX - startX;
        const dy = event.clientY - startY;
        if (slider.hasPointerCapture?.(pointerId)) slider.releasePointerCapture(pointerId);
        pointerId = null;
        applySwipe(dx, dy, 48);
        start();
      });
      slider.addEventListener('pointercancel', () => {
        pointerId = null;
        start();
      });
      slider.addEventListener('touchstart', (event) => {
        if (event.touches.length !== 1) {
          touchTracking = false;
          return;
        }
        const touch = event.touches[0];
        touchTracking = true;
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
        touchCurrentX = touch.clientX;
        touchCurrentY = touch.clientY;
        suppressClick = false;
        stop();
      }, { passive: true });
      slider.addEventListener('touchmove', (event) => {
        if (!touchTracking || event.touches.length !== 1) return;
        const touch = event.touches[0];
        touchCurrentX = touch.clientX;
        touchCurrentY = touch.clientY;
      }, { passive: true });
      slider.addEventListener('touchend', (event) => {
        if (!touchTracking) return;
        const touch = event.changedTouches[0];
        if (touch) {
          touchCurrentX = touch.clientX;
          touchCurrentY = touch.clientY;
        }
        touchTracking = false;
        applySwipe(touchCurrentX - touchStartX, touchCurrentY - touchStartY);
        start();
      }, { passive: true });
      slider.addEventListener('touchcancel', () => {
        touchTracking = false;
        start();
      }, { passive: true });
      slider.addEventListener('wheel', (event) => {
        if (Math.abs(event.deltaX) <= Math.abs(event.deltaY) * 1.05) return;
        event.preventDefault();
        stop();

        const now = window.performance.now();
        const magnitude = Math.abs(event.deltaX);
        const isNewGesture = now - wheelLastEventAt > 110
          || (wheelLocked
            && now - wheelLastChangeAt > 180
            && magnitude > Math.max(10, wheelPreviousMagnitude * 1.45));

        if (isNewGesture) {
          wheelDeltaX = 0;
          wheelLocked = false;
        }

        wheelLastEventAt = now;
        wheelPreviousMagnitude = magnitude;
        window.clearTimeout(wheelUnlockTimer);
        wheelUnlockTimer = window.setTimeout(() => {
          wheelDeltaX = 0;
          wheelLocked = false;
          wheelPreviousMagnitude = 0;
          start();
        }, 160);
        if (wheelLocked) return;
        wheelDeltaX += event.deltaX;
        if (Math.abs(wheelDeltaX) < 48) return;
        const direction = wheelDeltaX > 0 ? 1 : -1;
        wheelLocked = true;
        wheelLastChangeAt = now;
        wheelDeltaX = 0;
        show(current + direction);
      }, { passive: false });
      slider.addEventListener('click', (event) => {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
        suppressClick = false;
      }, true);
      slider.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        show(current + (event.key === 'ArrowRight' ? 1 : -1));
      });
      slider.addEventListener('mouseenter', () => {
        hovered = true;
        stop();
      });
      slider.addEventListener('mouseleave', () => {
        hovered = false;
        start();
      });
      slider.addEventListener('focusin', () => {
        focused = true;
        stop();
      });
      slider.addEventListener('focusout', (event) => {
        if (!slider.contains(event.relatedTarget)) {
          focused = false;
          start();
        }
      });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stop(); else start();
      });

      show(0);
      start();
    });
  };

  const initProductRails = (root = document) => {
    root.querySelectorAll('[data-ar-product-rail]:not([data-ar-rail-ready])').forEach((rail) => {
      rail.dataset.arRailReady = 'true';
      let pointerId = null;
      let startX = 0;
      let startScroll = 0;
      let suppressClickUntil = 0;
      let dragged = false;

      rail.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        pointerId = event.pointerId;
        startX = event.clientX;
        startScroll = rail.scrollLeft;
        dragged = false;
      });
      rail.addEventListener('pointermove', (event) => {
        if (event.pointerId !== pointerId) return;
        const dx = event.clientX - startX;
        if (!dragged && Math.abs(dx) > 8) {
          dragged = true;
          rail.classList.add('is-dragging');
          rail.setPointerCapture?.(pointerId);
        }
        if (!dragged) return;
        event.preventDefault();
        rail.scrollLeft = startScroll - dx;
      });
      const finish = (event) => {
        if (pointerId === null || (event && event.pointerId !== pointerId)) return;
        if (rail.hasPointerCapture?.(pointerId)) rail.releasePointerCapture(pointerId);
        if (dragged) suppressClickUntil = performance.now() + 180;
        dragged = false;
        pointerId = null;
        rail.classList.remove('is-dragging');
      };
      rail.addEventListener('pointerup', finish);
      rail.addEventListener('pointercancel', finish);
      rail.addEventListener('click', (event) => {
        if (performance.now() >= suppressClickUntil) return;
        event.preventDefault();
        event.stopPropagation();
        suppressClickUntil = 0;
      }, true);
    });
  };

  const init = (root = document) => {
    initSurpriseUpsell(root);
    initReveal(root);
    initFaq(root);
    initGallery(root);
    initVariants(root);
    initTalkButtonSets(root);
    initProductRails(root);
    initHeroSliders(root);
  };

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
